import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import DefaultCell from 'layouts/pages/orders/order-list/components/DefaultCell';
import AccionesCellDetalles from '../components/AccionesCellDetalles'; // Ajusta la ruta según corresponda
import { Button, Stack } from '@mui/material';
import Swal from 'sweetalert2';

// Componente para renderizar una celda por defecto
const RenderDefaultCell = ({ value }) => <DefaultCell value={value} />;
RenderDefaultCell.propTypes = {
  value: PropTypes.any,
};

const fetchTrafficDetalleData = async (
  id_orden_detalle,
  onEditTrafficDetail,
  onDeleteTrafficDetail
) => {
  try {
    // Solicitud GET utilizando el id_orden_detalle recibido
    const response = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/api/orders/traffic-details/`,
      { params: { id_orden_detalle } }
    );
    const detalleData = response.data;
    console.log(detalleData);

    // Mapeamos los datos para ajustar la estructura de la tabla.
    const rows = detalleData.map(item => ({
      // Asegúrate de que estos nombres coincidan con los que retorna tu API.
      nombre: item.nombre_transporte,
      navieraLinea: item.nav_linea,
      desde: item.desde,
      hasta: item.hasta,
      estado: item.estado,
      salida: item.fecha,   // Por ejemplo, 'fecha' para la salida
      estima: item.arribo,  // Por ejemplo, 'arribo' para la fecha estimada
      acciones: (
        <AccionesCellDetalles
          onEditDetalles={() => onEditTrafficDetail(item)}
          onDeleteDetalles={() => onDeleteTrafficDetail(item)}
        />
      ),
    }));

    return {
      columns: [
        {
          Header: 'Nombre',
          accessor: 'nombre',
          Cell: RenderDefaultCell,
        },
        {
          Header: 'Naviera o Línea Aérea',
          accessor: 'navieraLinea',
          Cell: RenderDefaultCell,
        },
        {
          Header: 'Desde',
          accessor: 'desde',
          Cell: RenderDefaultCell,
        },
        {
          Header: 'Hasta',
          accessor: 'hasta',
          Cell: RenderDefaultCell,
        },
        {
          Header: 'Estado',
          accessor: 'estado',
          Cell: RenderDefaultCell,
        },
        {
          Header: 'Salida',
          accessor: 'salida',
          Cell: RenderDefaultCell,
        },
        {
          Header: 'Estima',
          accessor: 'estima',
          Cell: RenderDefaultCell,
        },
        {
          Header: 'Acciones',
          accessor: 'acciones',
          Cell: ({ row }) => row.original.acciones,
        },
      ],
      rows,
    };
  } catch (error) {
    console.error('Error fetching traffic detalle data:', error);
    return { columns: [], rows: [] };
  }
};

export default fetchTrafficDetalleData;
